export default "__VITE_ASSET__CMO1Jl34__"